const root = "/billing-accounts";

export const returnToQuoteParam = "quoteId";

export function withReturnToQuote(path: string, odNumber: string | null) {
  return odNumber ? `${path}?${new URLSearchParams({ [returnToQuoteParam]: odNumber })}` : path;
}

export const billingAccountRoutes = {
  root: root,
  detail: (billingAccountCode: string) => ({
    root: `${root}/${billingAccountCode}`,
    returnToQuote: (odNumber: string) => withReturnToQuote(`${root}/${billingAccountCode}`, odNumber),
    subscriptions: `${root}/${billingAccountCode}/subscriptions`,
    history: `${root}/${billingAccountCode}/history`,
  }),
};
